module.exports = __webpack_public_path__ + "static/media/lungs.3ebed0bc.svg";